import ModalPageEvent from "../../components/Common/Modal/ModalPageEvent";
import FinancialSummaryDocument from "./FinancialSummaryDocument";

/**
 * O resumo financeiro aberto a partir do detalhe do extrato, sem sair da tela.
 *
 * O documento em si vive em FinancialSummaryDocument, compartilhado com a tela própria
 * do relatório: são dois caminhos para o mesmo papel, e ele não pode divergir entre eles.
 */
const EmployeeFinancialSummary = ({ show, setShow, ...documentProps }) => (
    <ModalPageEvent
        title="Resumo Financeiro"
        show={show}
        setShow={setShow}
        size="xl"
        child={<FinancialSummaryDocument {...documentProps} />}
    />
);

export default EmployeeFinancialSummary;
